var _rect, _g, _circle, _g2, _rect2, _rect3, _g3, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicInfoMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 235,
    viewBox: "0 0 298 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_7965)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.94524,
    y: 1.12308,
    width: 203.3,
    height: 299.39,
    rx: 17.4711,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 274.466 80.8375)",
    fill: "#F5F6F8",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 3.17656
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1355_7965)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.707,
    cy: 39.707,
    r: 39.707,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 202.04 119.322)",
    fill: "url(#paint0_linear_1355_7965)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.707,
    cy: 39.707,
    r: 42.8835,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 202.04 119.322)",
    stroke: "url(#paint1_linear_1355_7965)",
    strokeWidth: 6.35311
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1355_7965",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 107,
    width: 81,
    height: 81
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.707,
    cy: 39.707,
    r: 39.707,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 202.04 119.322)",
    fill: "url(#paint2_linear_1355_7965)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1355_7965)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.55 168.166C161.694 169.276 165.956 166.805 167.061 162.679L170.748 148.92C173.154 139.939 167.825 130.708 158.844 128.302C149.863 125.895 140.633 131.224 138.226 140.205L134.539 153.965C133.43 158.105 135.888 162.362 140.032 163.472L157.55 168.166Z",
    fill: "#1A358F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.967 153.801L158.977 157.823L153.28 179.088L138.27 175.066L143.967 153.801Z",
    fill: "#77A1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.243 151.994L166.572 154.496C164.54 162.082 156.713 166.601 149.126 164.569C141.54 162.536 137.021 154.709 139.054 147.122L139.724 144.621C140.28 142.548 142.41 141.318 144.482 141.874C148.839 143.041 153.281 141.579 156.122 138.46C157.024 142.582 160.139 146.069 164.496 147.236C166.568 147.792 167.798 149.922 167.243 151.994Z",
    fill: "#BED2F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.463 169.411L140.616 166.31C142.308 168.439 144.641 170.07 147.451 170.822C150.26 171.575 153.096 171.329 155.604 170.326L167.198 180.594C169.401 182.546 170.31 185.576 169.549 188.418L168.783 191.278C168.596 191.973 167.884 192.385 167.184 192.198L119.674 179.467C118.977 179.281 118.561 178.574 118.749 177.871L119.515 175.011C120.277 172.17 122.579 170.001 125.463 169.411Z",
    fill: "#3954AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.78 173.324C142.898 172.284 139.702 169.964 137.515 166.945L140.616 166.31C142.308 168.439 144.641 170.07 147.451 170.823C150.26 171.575 153.096 171.33 155.603 170.326L157.986 172.436C154.583 173.954 150.66 174.364 146.78 173.324Z",
    fill: "#1A358F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 130.239,
    height: 6.35311,
    rx: 3.17656,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 199.456 227.154)",
    fill: "#BED2F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.972618,
    y: 0.561541,
    width: 166.769,
    height: 23.8242,
    rx: 5.55897,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 209.11 257.935)",
    fill: "url(#paint3_linear_1355_7965)",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 1.58828
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1355_7965)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.5311,
    height: 63.5311,
    rx: 9.52967,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 298.322 180.443)",
    fill: "#F5F6F8",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.94524,
    y: 1.12308,
    width: 60.3546,
    height: 60.3546,
    rx: 7.94139,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 294.789 179.978)",
    stroke: "url(#paint4_linear_1355_7965)",
    strokeWidth: 3.17656
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.822 218.511C264.694 219.28 267.647 217.568 268.414 214.708L270.969 205.172C272.637 198.947 268.943 192.549 262.719 190.882C256.494 189.214 250.097 192.907 248.429 199.132L245.873 208.668C245.105 211.538 246.808 214.488 249.681 215.258L261.822 218.511Z",
    fill: "#BED2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.408 208.555L262.811 211.343L258.862 226.081L248.459 223.293L252.408 208.555Z",
    fill: "#F3F7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.54 207.303L268.075 209.037C266.666 214.295 261.242 217.427 255.984 216.018C250.726 214.609 247.594 209.184 249.003 203.926L249.467 202.192C249.852 200.756 251.328 199.903 252.765 200.288C255.784 201.097 258.863 200.084 260.832 197.922C261.457 200.779 263.616 203.196 266.636 204.005C268.072 204.39 268.925 205.866 268.54 207.303Z",
    fill: "#F3F7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.582 219.374L250.085 217.224C251.258 218.7 252.875 219.83 254.822 220.352C256.769 220.874 258.734 220.704 260.472 220.008L268.509 227.125C270.035 228.478 270.665 230.578 270.138 232.547L269.607 234.529C269.478 235.011 268.984 235.297 268.498 235.167L235.57 226.344C235.087 226.214 234.799 225.725 234.929 225.238L235.46 223.256C235.988 221.286 237.584 219.783 239.582 219.374Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.358 222.086C251.667 221.365 249.452 219.758 247.936 217.665L250.085 217.225C251.258 218.7 252.875 219.831 254.822 220.352C256.769 220.874 258.735 220.704 260.473 220.008L262.124 221.47C259.766 222.523 257.046 222.807 254.358 222.086Z",
    fill: "#BED2F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1355_7965",
    x: 90.6607,
    y: 92.5924,
    width: 125.497,
    height: 125.497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.94139
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.33846
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1355_7965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1355_7965",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1355_7965",
    x: 218.682,
    y: 162.168,
    width: 81.472,
    height: 81.4722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.98535
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1355_7965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1355_7965",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1355_7965",
    x1: 39.707,
    y1: 0,
    x2: 39.707,
    y2: 79.4139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1355_7965",
    x1: 39.707,
    y1: 0,
    x2: 39.707,
    y2: 79.4139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1355_7965",
    x1: 79.4139,
    y1: -2.95722,
    x2: 79.4139,
    y2: 79.4139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1355_7965",
    x1: 84.1787,
    y1: 0,
    x2: 84.1787,
    y2: 25.4125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1355_7965",
    x1: 55.6501,
    y1: -2.11175,
    x2: -7.44909,
    y2: 61.5519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_7965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298,
    height: 235,
    fill: "white",
    transform: "matrix(-1 0 0 1 298 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicInfoMobile);
export default __webpack_public_path__ + "static/media/basic-info-mobile.c2f34988f2c40781380182589e1ac692.svg";
export { ForwardRef as ReactComponent };